import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	settingsMenuItem: {
		padding: "15px"
	}
})

export default useStyles
